<section class="add-page-tooltip-container"
         dbStopPinchEvent
      (keyup.enter)="proceed(nameControl.value)"
      (dbClickOutside)="close.emit()">
  <div class="add-page-input-container">
    <div class="title-label">
      {{ 'text_addNewPageTitle' | dbText }} <span>*</span>
    </div>
    <input type="text" [formControl]="nameControl" class="ds-input-black" placeholder="">
  </div>
  <button class="ds-btn-purple-blue mt30"
          [ngClass]="{'ds-btn-disabled' : nameControl.invalid}"
          (click)="proceed(nameControl.value)">
    {{ 'text_proceed' | dbText }}
  </button>
</section>
